import { html, TemplateResult } from "lit-html";
import { repeat } from 'lit-html/directives/repeat';
import { ifDefined } from "lit-html/directives/if-defined";

const classInfo = (index: number, activeLocationIndex: number) => index === activeLocationIndex ? "active" : undefined;

export const LocationsListTemplate = (state: ILocationsListTemplateState, handlers: ILocationTypeaheadEventHandlers): TemplateResult => {

  const {
    locationsList,
    activeLocationIndex,
    locationsLimit
  } = state;

  const {
    handleClick,
    handleMouseEnter
  } = handlers

  return html`
    <ul role="listbox" aria-hidden="false" class="dropdown-menu ts-dropdown-menu" @click=${handleClick}>
      ${repeat(locationsList.slice(0, locationsLimit), (location: IAutocompleteLocationProvider) =>
    location.canonicalName, (location: IAutocompleteLocationProvider, index) => html`
        <li 
        tabindex="-1" 
        role="option"
        class=${ifDefined(classInfo(index, activeLocationIndex))}
        @mouseenter=${() => handleMouseEnter(index, locationsList)}
        >
          <a tabindex="-1">${location.canonicalName}</a>
        </li>
      `)}
    </ul>
    `;
}